<template>
  <div class="">
    <!-- RELEASES NOTES -->
    <div v-if="clickedOn === 'clickedOnReleases'" 
         id="checkbox-releases-notes">
      <span class="custom-control custom-switch my-3 d-flex justify-content-center">
        <input id="notificacoes"
               v-model="checkboxValue"
               type="checkbox"
               class="custom-control-input"
               :value="0"
               @change="$emit('updateCheckbox', checkboxValue)">
        <label class="custom-control-label text-left"
               for="notificacoes">Mostrar somente notificações não lidas</label>
      </span>
    </div> 

    <!-- CERTIDÕES PENDENTES CRC -->
    <div v-else-if="clickedOn === 'clickedOnCertidoesPendentesCRC'"
         id="pedidos-de-certidoes_modulos"
         class="mt-3">
      <ul class="nav nav-underline">
        <li
          v-for="modulo in modulos"
          :key="modulo"
          class="nav-item"
          style="position: relative;">
          <a
            href="#"
            class="nav-link"
            :style="{ fontSize: '0.9rem' }"
            :class="{ active: modulo === moduloClicado }"
            @click.prevent="selecionarModulo (modulo)">
            {{ modulo }}
          </a>
          
          <div :class="{'counterWrapper': contagemCertidoes[modulo].length }">
            {{ contagemCertidoes[modulo].length > 99 ? '99+' : contagemCertidoes[modulo].length || '' }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"

  export default {
    name: "MenuLateralHeader",
    data () {
      return {
        checkboxValue: false,
        moduloClicado: 'CRC',
        modulos: ['CRC', 'REG', 'JUD', 'EPR', 'RSE', 'EQB'],
        contagemCertidoes: {
          'CRC': [],
          'REG': [],
          'JUD': [],
          'EPR': [],
          'RSE': [],
          'EQB': []
        }
      }
    },
    computed: {
      ...mapGetters({
        clickedOn: 'releasesNotes/getClickedOn',
        pedidosPendentesBase: 'releasesNotes/getPedidosPendentesBase'
      })
    },
    watch: {
      pedidosPendentesBase () {
        this.resetarContagemCertidoesPorModulo ()
        this.contagemCertidoesPorModulo ()
      }
    },
    created () {
      this.selecionarModulo ()  // Atualização de "pedidosPendentesBase"
      this.selecionarModulo ('CRC') // Inicializa carregando a lista de pedidos pendentes do módulo CRC
      this.contagemCertidoesPorModulo()
    },
    methods: {
      contagemCertidoesPorModulo () {
        this.pedidosPendentesBase.forEach(certidao => {
          if (certidao.pedido.modulo) this.contagemCertidoes[certidao.pedido.modulo].push(certidao)
        })
      },
      resetarContagemCertidoesPorModulo () {
        Object.keys(this.contagemCertidoes).forEach(modulo => {
          this.contagemCertidoes[modulo] = []
        })
      },
      selecionarModulo (modulo) {
        if (modulo) this.moduloClicado = modulo
        this.$emit('certidoesPendentesModulo', modulo)
      }
    }
  }
</script>

<style scoped lang="scss">
.nav-link.active {
  text-decoration: underline;
  font-weight: bold;
}

.base {
  position: absolute;
  top: 3%;
  right:  5%;
  width: 1.1rem;
  height: 1.1rem;
  font-weight: 500;
  font-size: .7rem;
  border-radius: 100%;  
  display: flex;
  justify-content: center;
  align-items: center;
}

.counterWrapper {
  @extend .base;
  background: #8b0000;
  color: white;
}
</style>